import { render, staticRenderFns } from "./BlockAction.component.vue?vue&type=template&id=b97d36c0&"
import script from "./BlockAction.component.vue?vue&type=script&lang=js&"
export * from "./BlockAction.component.vue?vue&type=script&lang=js&"
import style0 from "./BlockAction.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports